import { createUseProvidedContext } from '@stenngroup/utilities';
import { BreadcrumbContainerContext } from './context';

export const useBreadcrumbsContainer = createUseProvidedContext(
  BreadcrumbContainerContext,
  'BreadcrumbContainerContext'
);
